window.onload=function(){
    const btn_search = document.querySelector(".btn-search");
    const btn_close = document.querySelector(".btn-close");
    const btn_menu = document.querySelector(".menu-burger");
    const site_header = document.querySelector(".site-header");
    const menu_open = document.querySelector(".menu-open");
    const main_navigation = document.querySelector(".main-navigation");
    const search_bar = document.querySelector(".search-bar");
    
    menu_open.classList.remove('hidden');
    search_bar.classList.remove('hidden');

    btn_menu.addEventListener('click', openMenu, false)
    function openMenu() {
        site_header.classList.toggle('active');
        btn_menu.classList.toggle('active');
        menu_open.classList.toggle('active');
        main_navigation.classList.toggle('active');    
    }
    btn_search.addEventListener('click', openSearch, false)
    btn_close.addEventListener('click', openSearch, false)
    function openSearch() {
        search_bar.classList.toggle('active');        
    }
}

window.onscroll = function() {myFunction()};

function myFunction() {
  var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
  var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  var scrolled = (winScroll / height) * 100;
  document.getElementById("myBar").style.width = scrolled + "%";
}

if (document.body.classList.contains('box-filter__btn')) {
    console.log('yes')
    const btnfilter = document.querySelector(".box-filter__btn")
    const boxfilter = document.querySelector(".box-filter__content")
    btnfilter.addEventListener('click', filterbox, false)
    function filterbox() {
        boxfilter.classList.toggle("active")
    }
}